<template>
  <ValidationProvider
    #default="validationContext"
    :ref="refName"
    :name="name"
    :vid="name"
    :rules="rules"
    tag="div">
    <b-form-group
      :label="label">
      <div class="d-flex align-items-center">
        <b-form-input
          v-model="innerValue"
          type="color"
          class="mr-1"
          style="max-width: 60px; height: 38px;"
          :state="$getValidationState(validationContext)"
          v-bind="$attrs"
          v-on="{...$listeners}"
        />
        <b-form-input
          v-model="innerValue"
          type="text"
          placeholder="#000000"
          :state="$getValidationState(validationContext)"
          v-bind="$attrs"
          v-on="{...$listeners}"
        />
      </div>
      <b-form-invalid-feedback>
        {{ validationContext.errors[0] }}
      </b-form-invalid-feedback>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    rules: {
      type: [String, Object],
      default: () => {}
    },
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    innerValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    refName () {
      return `validation-provider-${this.name}`
    }
  }
}
</script>

<style scoped>
input[type="color"] {
  cursor: pointer;
}
</style>

